<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
  <tui-breadcrumbs [itemsLimit]="10">
    <ng-container *ngFor="let item of breadcrumbs; let last = last">
      <ng-container *ngIf="last">
        <strong *tuiItem tuiFade>
          {{ item }}
        </strong>
      </ng-container>
      <ng-container *ngIf="!last">
        <button *tuiItem tuiLink type="button">
          {{ item }}
        </button>
      </ng-container>
    </ng-container>
  </tui-breadcrumbs>

  <button
    *ngIf="canPurgeAuditLogs"
    appearance="secondary"
    tuiButton
    type="button"
    style="border: 2px solid #e5e7ea; font-weight: 800"
    [tuiDropdown]="clearMenu"
  >
    Clear Old Logs
  </button>

  <ng-template #clearMenu>
    <tui-data-list tuiDataListDropdownManager>
      <button tuiOption type="button" (click)="clearOldLogs('6m')">
        Older than 6 months
      </button>
      <button tuiOption type="button" (click)="clearOldLogs('1y')">
        Older than 1 year
      </button>
    </tui-data-list>
  </ng-template>
</nav>

<div class="items-center flex justify-between">
  <p class="text-[1.25rem] font-bold mt-[0.9rem] text-[#000000A6]">Logs</p>
</div>

<div class="mt-4">
  <fieldset class="border-none">
    <div class="flex flex-wrap items-center gap-4">
      <div class="w-[280px]">
        <tui-combo-box
          [stringify]="stringifyClient"
          [(ngModel)]="selectedPatient"
          (ngModelChange)="applyFilters()"
        >
          Client
          <input
            tuiTextfieldLegacy
            placeholder="Select client"
            [value]="stringifyClient(selectedPatient)"
          />
          <tui-data-list-wrapper
            *tuiDataList
            [items]="clientOptions"
            [itemContent]="stringifyClient | tuiStringifyContent"
          />
        </tui-combo-box>
      </div>

      <div class="w-[280px]">
        <tui-combo-box
          [stringify]="stringifyStaff"
          [(ngModel)]="selectedStaff"
          (ngModelChange)="applyFilters()"
        >
          Staff / Actor
          <input
            tuiTextfieldLegacy
            placeholder="Select staff"
            [value]="stringifyStaff(selectedStaff)"
          />
          <tui-data-list-wrapper
            *tuiDataList
            [items]="staffOptions"
            [itemContent]="stringifyStaff | tuiStringifyContent"
          />
        </tui-combo-box>
      </div>

      <div class="w-[200px]">
        <tui-textfield>
          <input
            tuiTextfield
            type="date"
            [(ngModel)]="fromDate"
            (change)="applyFilters()"
            placeholder="From"
          />
        </tui-textfield>
      </div>

      <div class="w-[200px]">
        <tui-textfield>
          <input
            tuiTextfield
            type="date"
            [(ngModel)]="toDate"
            (change)="applyFilters()"
            placeholder="To"
          />
        </tui-textfield>
      </div>

      <button size="m" tuiButton type="button" (click)="clearFilters()">
        Clear Filters
      </button>
    </div>
  </fieldset>
</div>

<div *ngIf="isLoading" class="h-[400px]">
  <tui-loader />
</div>

<div
  *ngIf="!isLoading"
  class="w-full mt-5 md:overflow-x-scroll lg:overflow-x-scroll xl:overflow-x-scroll"
>
  <table tuiTable [size]="size" class="w-[100rem] md:w-[100rem] lg:w-[90rem] xl:w-[90rem] 2xl:w-[120rem]">
    <thead>
      <tr>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff; z-index: -10">
          Timestamp
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff; z-index: -10">
          Action
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff; z-index: -10">
          Actor
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff; z-index: -10">
          Target
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff; z-index: -10">
          Changes
        </th>
      </tr>
    </thead>

    <tbody tuiTbody>
      <tr *ngFor="let row of logs">
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ row?.createdAt | date : "MMM d, y, h:mm a" }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ row?.actionType }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ row?.metadata?.actor?.name || row?.actorType }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size" class="flex flex-col gap-0.5 items-start">
            <span class="text-[#191C30E5] text-sm font-medium">{{ row?.targetType || "—" }}</span>
            <span
              class="text-[#191C30B3] text-xs leading-snug max-w-[28rem]"
              *ngIf="row?.metadata?.target?.summary as targetSummary"
            >
              {{ targetSummary }}
            </span>
            <span
              class="text-[#191C30B3] text-xs font-mono"
              *ngIf="!row?.metadata?.target?.summary && row?.targetId"
            >
              {{ row.targetId }}
            </span>
            <span class="text-[#191C30B3] text-xs" *ngIf="!row?.targetType && !row?.targetId">—</span>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ row?.metadata?.changedFields ? (row?.metadata?.changedFields | json) : "-" }}
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="flex justify-end items-center mt-5">
  <tui-pagination
    [index]="pageIndex - 1"
    [length]="getPageCount()"
    (indexChange)="onPageChange($event + 1)"
  >
  </tui-pagination>
</div>

